export default "/_next/static/47b1ae921ed1dd708d76a5b2143c65e2.png";